var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-wrapper"},[_c('page-header'),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("default")],2),_vm._v(" "),_c('ics-toaster'),_vm._v(" "),_c('page-footer',[_c('template',{slot:"copyright"},[_vm._v("© Scildon "+_vm._s(_vm.year)+" ")])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }